import { render, staticRenderFns } from "./Anggota.vue?vue&type=template&id=d4368486"
import script from "./Anggota.vue?vue&type=script&lang=js"
export * from "./Anggota.vue?vue&type=script&lang=js"
import style0 from "./Anggota.vue?vue&type=style&index=0&id=d4368486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports